const setServiceImplementation = ({
  getSidePanelKey,
  getSidePanelState,
  handleSidePanelChange,
}) => {
  if (getSidePanelKey) publicAPI.getSidePanelKey = getSidePanelKey;
  if (getSidePanelState) publicAPI.getSidePanelState = getSidePanelState;
  if (handleSidePanelChange)
    publicAPI.handleSidePanelChange = handleSidePanelChange;
};

const setState = state => (publicAPI.state = state);

const publicAPI = {
  state: undefined,
  setState,
  getSidePanelKey: () => console.warn('getSidePanelKey() NOT IMPLEMENTED'),
  getSidePanelState: () => console.warn('getSidePanelState() NOT IMPLEMENTED'),
  handleSidePanelChange: () =>
    console.warn('handleSidePanelChange() NOT IMPLEMENTED'),
  setServiceImplementation,
};

export default {
  name: 'SidePanelService',
  create: ({ configuration = {} }) => {
    return publicAPI;
  },
};
